<!--
 * @Date: 2023-02-16 14:48:25
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-07-18 11:25:27
 * @FilePath: \cms_main_site\src\components\layout\Main.vue
-->
<template>
  <el-container direction="vertical">
    <page-header :class="{'fixed': isScroll}" ref="header" :menu="menu" :site-info="siteInfo"></page-header>
    <div class="pages-main" :class="!isHome && 'pages-main--pt'">
      <keep-alive>
        <router-view :key="$route.name" v-if="isKeepAlive"></router-view>
      </keep-alive>
      <router-view :key="$route.name" v-if="!isKeepAlive"></router-view>
    </div>
    <page-footer :site-info="siteInfo"></page-footer>
  </el-container>
</template>

<script>
import PageHeader from './Header.vue'
import PageFooter from './Footer.vue'

export default {
  components: {
    PageHeader,
    PageFooter
  },
  computed: {
    isHome () {
      return this.$route.name === 'home'
    },
    menu () {
      return (this.$store.state.site.navList || [])
      // .concat({
      //   navTitle: '智能体',
      //   target: 1, // 1 新窗口打开
      //   isStress: true, // 是否强调
      //   navUrl: '/agents/center'
      // })
    },
    isKeepAlive () {
      return !!this.$route.meta.isKeepAlive
    },
    siteInfo () {
      return this.$store.state.site
    }
  },
  data () {
    return {
      breadcrumb: [],
      isScroll: false
    }
  },
  methods: {},
  mounted () {
    window.addEventListener('scroll', () => {
      if (document.documentElement.scrollTop > 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    })
  },
  created () {
    this.$bus.$on('breadcrumb-change', (breadcrumb) => {
      this.breadcrumb = breadcrumb
    })
  }
}
</script>

<style lang="stylus" scoped>
.pages-main
  min-height calc(100vh - 265px)
.pages-main--pt  
  padding-top: 60px
// .fixed
//   top 0
//   left 0
//   width 100%
//   z-index $highestIndex
//   background #fff
//   position fixed
</style>
